<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
</template>

<script>
const TableName = 'VUETABLE_CATEGORY_SALES';
export default {
    data: function() {
        return {
            tableName: TableName,
            columns: [
                'code',
                'name',
                'tags',
                'total_quantity',
                'total_gross_sales',
                'total_net_sales',
                'total_cost',
                'total_margin',
            ],
            options: {
                skin: 'table m-b-0 b-b',
                texts: {
                    title: 'Product Sales by Category',
                    description: 'Shows product sales by category',
                },
                templates: {
                    total_net_sales: (h, row) => {
                        if (row.parent) {
                            return '';
                        }
                        return numeral(
                            parseFloat(row.total_net_sales),
                        ).format();
                    },
                    total_cost: (h, row) => {
                        if (row.parent) {
                            return '';
                        }
                        return numeral(parseFloat(row.total_cost)).format();
                    },
                    total_margin: (h, row) => {
                        if (row.parent) {
                            return '';
                        }
                        return numeral(parseFloat(row.total_margin)).format();
                    },
                },
                customFilters: ['outlet_id', 'since', 'until'],
                useReportFilter: true,
                headings: {
                    name: 'Product',
                    total_net_sales: 'Total net sales',
                },
                orderBy: {
                    ascending: true,
                    column: 'name',
                },
                pdf_url: Laroute.route(
                    'franchise.report.item.export_category_sales',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.item.export_category_sales',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.item.export_category_sales',
                    { type: 'XLSX' },
                ),
                responseAdapter(res) {
                    const data = res.data.data;
                    const grouped = _.groupBy(data, 'category');
                    const results = [];

                    _.forEach(grouped, (rows, categoryName) => {
                        results.push({
                            code: categoryName,
                            parent: true,
                        });

                        rows.forEach(row => {
                            row.parent = false;
                            results.push(row);
                        });
                    });

                    return {
                        data: results,
                        count: res.data.count,
                    };
                },
                rowClassCallback(row) {
                    if (row.parent) {
                        return 'table-row-divider';
                    }

                    return null;
                },
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('franchise.report.item.category_sales');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/vuetable-category-sales.vue